module.exports = __webpack_public_path__ + "static/media/chat.7ad054ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/UnifiedMessaging/chat.svg
// module id = 1847
// module chunks = 0